import React from 'react'
import { observer } from 'mobx-react-lite'
import { THEME } from 'utils'
import { useStore } from 'hooks'
import { AuthorsStore } from 'stores/authors'
import AuthorHero from 'components/AuthorHero'
import Sidebar from 'components/Sidebar'
import StoryList from 'components/StoryList'

const AuthorDetailContainer = ({ items, next, hasMore, page, adSettings }) => {
  const authorsStore = useStore(AuthorsStore)
  const author = authorsStore.current
  return (
    <>
      <AuthorHero author={author} />
      <div className='container'>
        <div className='row row--main'>
          <div className='col col--main'>
            <div className='storyList'>
              <h1 className='storyListTitle'>Latest From {author.name}</h1>
              <StoryList items={items} next={next} hasMore={hasMore} disableNativeAds />
            </div>
          </div>
          <div className='col col--sidebar'>
            <Sidebar adTag='Feed' page={page} adSettings={adSettings} />
          </div>
        </div>
      </div>
      <style jsx>{`
        .sidebar {
          display: none;
          max-width: 300px;
          margin-left: auto;
        }
        .container {
          background: #f5f5f5;
        }
        .storyListTitle {
          font-family: ${THEME.FONTS.BEBAS};
          font-size: 1.875rem;
          font-weight: 600;
          text-transform: uppercase;
          color: ${THEME.COLORS.SECONDARY};
          line-height: 1.2;
          padding: 0.75rem 1.125rem;
          margin: 0;
        }
        .col--sidebar {
          margin-top: 20px;
          min-width: 0;
          flex-basis: auto;
        }
        .col--main {
          padding: 0;
        }
        .storyList {
          background: #fff;
          box-shadow: ${THEME.BOX_SHADOW.DEFAULT};
        }
        @media (min-width: ${THEME.BREAKPOINTS.SM}px) {
          .sidebar {
            display: block;
          }
          .col--main {
            flex-basis: 66.66667%;
            padding: 0 0.9375rem;
            min-width: 0%;
          }
          .col--sidebar {
            flex-basis: 33.3333%;
          }
          .container {
            padding: 0 20px;
          }
          .storyList {
            margin-top: 20px;
          }
        }
        @media (min-width: ${THEME.BREAKPOINTS.XL}px) {
          .col--main {
            flex-basis: 70%;
          }
          .col--sidebar {
            flex-basis: 30%;
          }
        }
      `}</style>
    </>
  )
}

export default observer(AuthorDetailContainer)
